import { SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styles from "./categories.module.css";
import { FaArrowRightLong } from "react-icons/fa6";
import {
  BreadCrumb,
  HeadingTitle,
  Button,
  SubHeadingTitle,
  Banner,
  Image,
  SwiperSlider,
} from "../../shared/index";

const Categories = ({ variant = "home", categories = [] }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const parts = pathname.split("/");
  const categoryPath = parts[parts.length - 1];
  const BASE_PATH = "/"; 

const handleSubCategory = (slug) => {
  navigate(`/shop?category=${slug}`);
};  

  const categoryVariant =
    variant === "page"
      ? styles.categories__wrapper__page
      : styles.categories__wrapper__home;

  return (
    <section className={`${styles.categories__main} ${variant === "page" ? styles.categories__main__page : styles.categories__main__home}`}>
      {variant === "page" && (
        <>
          <BreadCrumb
            customPaths={[{ label: "Categories", path: categoryPath }]}
          />
          <Banner
            // heading={`Shine bright with \n Timeless Treasures`}
            imageUrl="/categories.png"
          />
        </>
      )}

      <div className={categoryVariant}>
        {variant === "page" && (
          <div className={styles.bestsellers}>
            <SubHeadingTitle
              subTitle={"free shipping for"}
              style={styles.bestsellers__subheading}
            />
            <HeadingTitle
              text="the bestsellers"
              style={styles.bestsellers__heading}
            />
            <SubHeadingTitle
              subTitle="At Azzana, we believe that you deserve the best, and that you should
                        not choose between quality, affordable prices,and real values.At Azzana,
                        we believe that you deserve the best, and that you should not choose
                        between quality, affordable prices, and real values. At Azzana, we believe
                        that you deserve the best."
              style={styles.bestsellers__paragraph}
            />
            <Link className={styles.view} to={"/shop"}>
              View <FaArrowRightLong size={20} />
            </Link>
          </div>
        )}

        {variant === "home" ? (
          <div className={styles.categories__slider}>
            <SwiperSlider
              prevId="catPrevBtn"
              nextId="catNextBtn"
              wrapperClass={styles.categories__slider}
              prevBtnClass={`${styles.navButton} ${styles.prevButton}`}
              nextBtnClass={`${styles.navButton} ${styles.nextButton}`}
              slidesPerView={3}
              spaceBetween={16}
              breakpoints={{
                320: { slidesPerView: 2 },
                640: { slidesPerView: 4 },
                1024: { slidesPerView: 6 },
              }}
            >
              {categories?.map((item) => (
                <SwiperSlide key={item?.slug}>
                  <div
                    className={styles.category__card}
                    onClick={() => handleSubCategory(item?.slug)}
                  >
                    <Image
                      src={`${process.env.REACT_APP_IMAGE_PATH}/${item?.cat_image}`}
                      alt={item?.slug}
                      className={styles.cat__home_image}
                    />
                    <HeadingTitle
                      text={item?.name}
                      style={styles.cat__heading}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </SwiperSlider>
          </div>
        ) : (
          <>
            {categories?.map((item) => (
              <div
                key={item?.slug}
                className={styles.category__card}
                onClick={() => handleSubCategory(item?.slug)}
              >
                <Image
                  src={`${process.env.REACT_APP_IMAGE_PATH}/${item?.cat_image}`}
                  alt={item?.slug}
                  className={styles.cat__home_image}
                />

                {variant === "home" && (
                  <HeadingTitle text={item?.name} style={styles.cat__heading} />
                )}

                {variant === "page" && (
                  <div className={styles.overlay}>
                    <HeadingTitle
                      text={item?.name}
                      style={styles.cat__heading}
                    />
                    <Button
                      title="Discover"
                      type="button"
                      style={styles.button}
                      onHandler={() => handleSubCategory(item?.slug)}
                    />
                  </div>
                )}
              </div>
            ))}
          </>
        )}
      </div>
    </section>
  );
};

export default Categories;
